
import { defineComponent, computed } from "vue";
import moment from "moment";

export default defineComponent({
  name: "EventDates",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const start = computed(() => moment.utc(props.data.in_date));
    const end = computed(() => moment.utc(props.data.out_date));
    return { start, end };
  },
});
